import React from "react";

function TaggingTable() {
  return <div>TaggingTable</div>;
}

export default TaggingTable;
